import { supabase } from "@/integrations/supabase/client";

export async function getChatWithMessages(chatId: string) {
  // load chat content
  const { data: content, error: contentError } = await supabase
    .from("content")
    .select("*")
    .eq("id", chatId)
    .single();

  if (contentError) throw contentError;

  // load messages
  const { data: messages, error: messagesError } = await supabase
    .from("chat_messages")
    .select("*")
    .eq("content_id", chatId)
    .order("created_at", { ascending: true });

  if (messagesError) throw messagesError;

  return { content, messages };
}
